import { render, staticRenderFns } from "./userAdmin.vue?vue&type=template&id=73feefbd&scoped=true&"
import script from "./userAdmin.vue?vue&type=script&lang=js&"
export * from "./userAdmin.vue?vue&type=script&lang=js&"
import style0 from "./userAdmin.vue?vue&type=style&index=0&id=73feefbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73feefbd",
  null
  
)

export default component.exports